import { createFileRoute } from '@tanstack/react-router';

import { StatementsPage } from '@/features/staff-commission';
import { workspaceSearchSchema } from '@/patterns';
import { currentPeriod } from '@/shared/lib/dates';
import { zSearchText } from '@/shared/lib/search';

export const Route = createFileRoute('/_app/staff-commission/statements/')({
  validateSearch: workspaceSearchSchema.extend({ new: zSearchText() }),
  staticData: { crumb: 'staffCommission:nav.statements' },
  component: function StaffCommissionList() {
    const search = Route.useSearch();
    const navigate = Route.useNavigate();
    const onSearchChange = (patch: Record<string, unknown>, o?: { replace?: boolean }) =>
      void navigate({ search: (prev) => ({ ...prev, ...patch }), replace: o?.replace ?? false });
    return (
      <StatementsPage
        search={search}
        period={search.period ?? currentPeriod()}
        staffType={search.staffType}
        onScopeChange={(patch) => onSearchChange({ ...patch, page: undefined })}
        onSearchChange={onSearchChange}
      />
    );
  },
});
